import { Component, Input, OnInit } from '@angular/core';

export interface IProgressBarData {
  values: IProgressBarOption[];
}

export interface IProgressBarOption {
  id: number;
  state: 'good' | 'wrong' | 'done' | null,
  open: boolean,
  questionId?: number;
  correct?: boolean;
}

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.less']
})
export class ProgressBarComponent implements OnInit {
  @Input() values: IProgressBarOption[] = [];
  @Input() active: number | null = null;
  constructor() { }

  ngOnInit(): void {
  }

}
